<adapt-dialog [maxWidth]="600">
    <h3 adapt-dialog-title>Edit group location</h3>

    <div adapt-dialog-content>
        <adapt-edit-team-locations [team]="team"
                                   (entitiesPopulated)="onLocationsPopulated($event)"
                                   (entityChanged)="addEntitiesToConfirm([$event])"></adapt-edit-team-locations>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [discardConfirmationInstance]="instance"> </adapt-standard-dialog-buttons>
</adapt-dialog>
